// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yY9H","question":"styles_question__2pxLs","description":"styles_description__QFP3b"};